import React from 'react';
import { QuoteIcon, StarIcon } from 'lucide-react';
import { testimonials } from '../data/product';
export function Testimonials() {
  return <section className="bg-navy px-4 py-6 sm:py-8" data-id="element-177" data-mp="3kr5uq9dydbmc">
      <div className="mx-auto max-w-5xl" data-id="element-178" data-mp="3fz5mltnqbceo">
        <h2 className="text-center text-2xl text-white sm:text-4xl" data-id="element-179" data-mp="3fxumc3thsmsb">
          WHAT TECHNICIANS SAY
        </h2>

        <ul className="mt-4 grid gap-2.5 md:grid-cols-2" data-id="element-180" data-mp="3ayhzhj2mffpq">
          {testimonials.map((testimonial, index) => <li key={testimonial.name} className={`flex flex-col rounded-xl border border-cyan/25 bg-white p-4 shadow-sm ${index === 0 ? 'md:col-span-2' : ''}`} data-id="element-181" data-mp="31zw8czj32sdc" data-mpi={index}>
              <div className="flex items-center gap-2" data-id="element-182" data-mp="2s2i1nrmyphy8">
                <QuoteIcon className="h-5 w-5 shrink-0 text-auto" aria-hidden="true" data-id="element-183" data-mp="2s430htgb7n1w" />
                <span className="flex gap-0.5" aria-label="5 out of 5" data-id="element-184" data-mp="qa3qdbexbbqs">
                  {[0, 1, 2, 3, 4].map(star => <StarIcon key={star} className="h-4 w-4 fill-[#F5A623] text-[#F5A623]" aria-hidden="true" data-id="element-185" data-mp="h4ddqnyh7s58" />)}
                </span>
              </div>
              <p className="mt-2 text-sm font-medium leading-snug text-ink/85" data-id="element-186" data-mp="c6bvg58vjwut">
                {testimonial.quote}
              </p>
              <p className="mt-auto pt-2 font-display text-lg uppercase leading-none text-navy" data-id="element-187" data-mp="zxr38djf76dg">
                {testimonial.name}
              </p>
              <p className="font-mono text-[11px] uppercase tracking-wide text-ink/60" data-id="element-188" data-mp="q6wdgz6yton9">
                {testimonial.role} · {testimonial.location}
              </p>
            </li>)}
        </ul>
      </div>
    </section>;
}